import { Component  } from "react";
import HomePage from "../Components/HomePage/HomePage";
import {traceView} from "../Components/Globals/Globals"

class HomePageView extends Component{
    constructor(props){
        super(props)

        traceView("HomePage")
    }

    render(){
        return(
            <>
              <HomePage/>  
            </>
        )
    }
}

export default HomePageView;